/* Copyright (c) 2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */
export interface AppTheme {
    name: string; // visible name of theme eg: Light/Dark/System
    key: string; // ID of the theme eg: light-theme/dark-theme
    className: string; // className which is applied to the body for the theme eg: light-theme-> light-theme
    isSystemTheme?: boolean; // Optional param to determine if the theme is system/auto theme
    isDefaultTheme?: boolean; // Optional param to determine if the theme is a default selected theme
}

export const AppThemes: AppTheme[] = [
    {
        name: 'Dark',
        key: 'dark',
        className: '',
        isDefaultTheme: true
    },
    {
        name: 'Light',
        key: 'light',
        className: 'light-theme'
    },
    {
        name: 'System',
        key: 'system',
        className: '',
        isSystemTheme: true
    }
];

// Key for user theme preference in storage.
export const UserThemePreferenceKey = 'userThemePreference';

// Payload for Nvkvstorage.Read command.
export interface NvkvstorageReadPayload {
    key: string;
}

// Payload for Nvkvstorage.Write command.
export interface NvkvstorageWritePayload {
    key: string;
    value: string;
}

// Payload for Nvkvstorage.Delete command.
export interface NvkvstorageDeletePayload {
    key: string;
}
export interface SetCEFThemePayload {
    systemTheme: string;
}
